module.exports = __webpack_public_path__ + "static/media/bg-10.39580ee8.png";